"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *
 *
 * @param {Recover} recover A reference to the Recover class
 * @class Dashboard
 * @classdesc Is used to return all legal dashboard actions
 */
var Dashboard = /** @class */ (function () {
    function Dashboard(recover) {
        var _this = this;
        this.recover = recover;
        /**
         *
         *
         * @memberof Dashboard
         * @returns {ISuccessfulIndexDashboardResponse} Returns all debts that require a
         * @description Returns a list of values for each status
         */
        this.get = function () {
            return _this.recover.request('/dashboard', 'GET', null, null);
        };
    }
    return Dashboard;
}());
exports.default = Dashboard;
